import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";

const reveal = {
  initial: { opacity: 0, y: 36 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-70px" },
  transition: { duration: 1, ease: [0.22, 1, 0.36, 1] },
};

export const Reserve = () => {
  const { t } = useLang();
  return (
    <section className="reserve" id="reserve" data-testid="reserve-section">
      <div className="container">
        <motion.div {...reveal}>
          <p className="label">{t.reserve.label}</p>
          <h2 className="reserve__title">
            {t.reserve.titleA} <em>{t.reserve.titleB}</em> {t.reserve.titleC}
          </h2>
          <p className="reserve__note">{t.reserve.note}</p>

          <a href="tel:+306936614442" className="reserve__phone" data-testid="reserve-phone-cta">
            <span className="reserve__phone-label">{t.reserve.callUs}</span>
            <span className="reserve__phone-num">{t.reserve.phone}</span>
          </a>
          <p className="reserve__sunset">{t.reserve.sunset}</p>
        </motion.div>

        <motion.div className="reserve__info" {...reveal}>
          <div className="reserve__block" data-testid="reserve-hours">
            <p className="reserve__block-label">{t.reserve.hoursLabel}</p>
            <p>{t.reserve.hours}</p>
          </div>
          <div className="reserve__block" data-testid="reserve-location">
            <p className="reserve__block-label">{t.reserve.whereLabel}</p>
            <p>{t.reserve.where}</p>
            <p className="reserve__muted">{t.reserve.where2}</p>
            <a
              href="https://maps.google.com/?q=Varkiza+Beach"
              target="_blank"
              rel="noreferrer"
              className="reserve__map-link"
              data-testid="reserve-map-link"
            >
              Google Maps ↗
            </a>
          </div>
          <div className="reserve__block" data-testid="reserve-follow">
            <p className="reserve__block-label">{t.reserve.followLabel}</p>
            <a href="https://www.instagram.com/vammos.sandlife/" target="_blank" rel="noreferrer" className="reserve__ig">
              @vammos.sandlife
            </a>
            <a href="https://www.facebook.com/profile.php?id=61591432117495" target="_blank" rel="noreferrer" className="reserve__ig">
              Facebook · VAMMOS sand life
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Reserve;
